const okLoansReducers = require('./reducers');
const okLoansViews = require('./routes');
const okLoansComponents = require('./components');
const okLoanActions = require('./actions')

module.exports = {
    okLoansReducers,
    okLoansViews,
    okLoansComponents,
    okLoanActions
};
